import { render, staticRenderFns } from "./DocumentEditorMenu.vue?vue&type=template&id=3d0fe894&scoped=true&"
import script from "./DocumentEditorMenu.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditorMenu.vue?vue&type=style&index=0&id=3d0fe894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0fe894",
  null
  
)

export default component.exports